import mfaAndResetDeliveryOptionsTemplate from "./mfaAndResetDeliveryOptionsTemplate";

const mfaActivationCodeTemplate = `
<div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 registration" data-ng-init="">
    <div class="inner-container with-padding with-shadow">
        <div class="block-title-linking" data-ng-repeat="planValue in plansFromCurrentContext">
            <b>{{planValue.planName }}</b>
        </div>

        <header class="contained-form-header margin-top-default">
            <p id="mfa-enter-code-header"> {{ 'activationCodeDeliveryOptions.intro' | translate }} </p>
        </header>

        <form 
            role="form" 
            id="oneIdActivationCodeForm" 
            data-ng-init="OneIdMfaController.getDeliveryOptions()"
            data-ng-submit="createAndDeliverActivationCodePOST('mfa')" 
            name="oneIdActivationCodeForm" 
            autocomplete="off"
            novalidate
        >
            ${mfaAndResetDeliveryOptionsTemplate}
        </form>
    </div>
    <!--/inner-container with-padding with-shadow/-->
    <!--todo: reformat to common component-->
</div>
`;
export default mfaActivationCodeTemplate;
